export class UnitsModel {
 UnitId:number;
 Name:string;
}

export class UnitsSearchFields {
  UnitId: number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}
export class PageResultDto {
  ClientCode: string;
  PageCount: number;
  PageNo: number;
  PageSize: number;
  TotalRecords: number;
}

export class GraphConfigModel{
  GraphConfigId:number;
  GraphTemplateTypeId:number;
  GraphDesc:string;
  GraphTypeId:number;
  charIds:number[];
  GraphOrderId:number;
}

export class AreaSearchFields {
  AreaId: number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}
export class ShipSearchFields {
  ShipId: number;
  Name: string; 
  PageNo: number;  
  PageSize: number;
}

export class RecommendationSearchFields {
  RecommendationId: number;
  Recommendation: string; 
  SampleTypeId:number;
  PageNo: number;  
  PageSize: number;
}

export class RecommendationModal{
  RecommendationId:number;
  Recommendation:string;
}